import CodeDelivery from './CodeDelivery';

export default CodeDelivery;
